'use strict';

angular.module('informaApp')
    .service('ExportReferrerTypes', function () {
        return {
            ganttChart: 2,
            chartView: 3,
            trendsView: 4
        }
    });